function CalendarIcon({ size = '24', style = {} }) {
  return (
    <svg
      style={{ ...style }}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 5.75C2 4.7835 2.7835 4 3.75 4H19.75C20.7165 4 21.5 4.7835 21.5 5.75V19.75C21.5 20.7165 20.7165 21.5 19.75 21.5H3.75C2.7835 21.5 2 20.7165 2 19.75V5.75ZM3.75 5.5C3.61193 5.5 3.5 5.61193 3.5 5.75V8.26667H20V5.75C20 5.61193 19.8881 5.5 19.75 5.5H3.75ZM20 9.76667H3.5V19.75C3.5 19.8881 3.61193 20 3.75 20H19.75C19.8881 20 20 19.8881 20 19.75V9.76667Z"
        fill="url(#paint0_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75 2C7.16421 2 7.5 2.33579 7.5 2.75V5.75C7.5 6.16421 7.16421 6.5 6.75 6.5C6.33579 6.5 6 6.16421 6 5.75V2.75C6 2.33579 6.33579 2 6.75 2Z"
        fill="url(#paint1_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.75 2C17.1642 2 17.5 2.33579 17.5 2.75V5.75C17.5 6.16421 17.1642 6.5 16.75 6.5C16.3358 6.5 16 6.16421 16 5.75V2.75C16 2.33579 16.3358 2 16.75 2Z"
        fill="url(#paint2_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 11.75C18.5 12.1642 18.1642 12.5 17.75 12.5H15.75C15.3358 12.5 15 12.1642 15 11.75C15 11.3358 15.3358 11 15.75 11H17.75C18.1642 11 18.5 11.3358 18.5 11.75Z"
        fill="url(#paint3_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 17.75C18.5 18.1642 18.1642 18.5 17.75 18.5H15.75C15.3358 18.5 15 18.1642 15 17.75C15 17.3358 15.3358 17 15.75 17H17.75C18.1642 17 18.5 17.3358 18.5 17.75Z"
        fill="url(#paint4_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 11.75C13.5 12.1642 13.1642 12.5 12.75 12.5H10.75C10.3358 12.5 10 12.1642 10 11.75C10 11.3358 10.3358 11 10.75 11H12.75C13.1642 11 13.5 11.3358 13.5 11.75Z"
        fill="url(#paint5_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 17.75C13.5 18.1642 13.1642 18.5 12.75 18.5H10.75C10.3358 18.5 10 18.1642 10 17.75C10 17.3358 10.3358 17 10.75 17H12.75C13.1642 17 13.5 17.3358 13.5 17.75Z"
        fill="url(#paint6_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 11.75C8.5 12.1642 8.16421 12.5 7.75 12.5H5.75C5.33579 12.5 5 12.1642 5 11.75C5 11.3358 5.33579 11 5.75 11H7.75C8.16421 11 8.5 11.3358 8.5 11.75Z"
        fill="url(#paint7_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 17.75C8.5 18.1642 8.16421 18.5 7.75 18.5H5.75C5.33579 18.5 5 18.1642 5 17.75C5 17.3358 5.33579 17 5.75 17H7.75C8.16421 17 8.5 17.3358 8.5 17.75Z"
        fill="url(#paint8_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 14.75C18.5 15.1642 18.1642 15.5 17.75 15.5H15.75C15.3358 15.5 15 15.1642 15 14.75C15 14.3358 15.3358 14 15.75 14H17.75C18.1642 14 18.5 14.3358 18.5 14.75Z"
        fill="url(#paint9_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 14.75C13.5 15.1642 13.1642 15.5 12.75 15.5H10.75C10.3358 15.5 10 15.1642 10 14.75C10 14.3358 10.3358 14 10.75 14H12.75C13.1642 14 13.5 14.3358 13.5 14.75Z"
        fill="url(#paint10_linear)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 14.75C8.5 15.1642 8.16421 15.5 7.75 15.5H5.75C5.33579 15.5 5 15.1642 5 14.75C5 14.3358 5.33579 14 5.75 14H7.75C8.16421 14 8.5 14.3358 8.5 14.75Z"
        fill="url(#paint11_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="-7.75"
          y1="12.75"
          x2="9.64803"
          y2="32.1364"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="5.25"
          y1="4.25"
          x2="7.95"
          y2="5.15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="15.25"
          y1="4.25"
          x2="17.95"
          y2="5.15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="16.75"
          y1="10.25"
          x2="15.6638"
          y2="12.7845"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
        <linearGradient
          id="paint4_linear"
          x1="16.75"
          y1="16.25"
          x2="15.6638"
          y2="18.7845"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
        <linearGradient
          id="paint5_linear"
          x1="11.75"
          y1="10.25"
          x2="10.6638"
          y2="12.7845"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
        <linearGradient
          id="paint6_linear"
          x1="11.75"
          y1="16.25"
          x2="10.6638"
          y2="18.7845"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
        <linearGradient
          id="paint7_linear"
          x1="6.75"
          y1="10.25"
          x2="5.66379"
          y2="12.7845"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
        <linearGradient
          id="paint8_linear"
          x1="6.75"
          y1="16.25"
          x2="5.66379"
          y2="18.7845"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
        <linearGradient
          id="paint9_linear"
          x1="16.75"
          y1="13.25"
          x2="15.6638"
          y2="15.7845"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
        <linearGradient
          id="paint10_linear"
          x1="11.75"
          y1="13.25"
          x2="10.6638"
          y2="15.7845"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
        <linearGradient
          id="paint11_linear"
          x1="6.75"
          y1="13.25"
          x2="5.66379"
          y2="15.7845"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3A416F" />
          <stop offset="1" stopColor="#141727" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default CalendarIcon;
